<div class="update-overlay" *ngIf="updateApp">
  <div textSmall>Eine neue Version für diese Website ist verfügbar!</div>
  <pezi-button text="Jetzt laden" [isPlain]="true" icon="refresh" (click)="reloadPage()"></pezi-button>
</div>
<div class="header-bar" [ngClass]="{ 'handset': deviceService.isHandset() }" [ngClass]="stage">
  <button class="header-button" mat-icon-button *ngIf="deviceService.isMobile()"
          (click)="mainSideNav.toggleDrawer()">
    <mat-icon>menu</mat-icon>
  </button>
  <div class="logo-box" (click)="routerService.navigateHome()" matTooltip="Startseite"
       [ngClass]="{ 'handset-logo-box': deviceService.isHandset() }">
    <span class="app-header-title-logo">
        <img ngSrc="../../assets/nv_logo_2022.svg" alt="Logo NV" height="35" width="48"/>
      </span>
    <span class="app-header-title-name" *ngIf="!deviceService.isHandset()">
        COCKPIT {{ getStageText() }}
      </span>
  </div>
  <div class="banner-nv-container">
    <img class="banner-nv" src="../../assets/banner-nv-veraenderung.png" alt="Veränderung als Chance"/>
  </div>
  <div class="action-area" *ngIf="loggedInUser">
    <app-fast-search [showSearch]="showSearch" (activeChanged)="showSearch=$event"></app-fast-search>
    <button mat-icon-button class="search-ele" (click)="showSearch=!showSearch" *appHasRightId="fastsearchRight"
            matTooltip="Suchen">
      <mat-icon>search</mat-icon>
    </button>
    <button mat-icon-button (click)="dlHandbuch()" matTooltip="Handbuch öffnen">
      <mat-icon>menu_book</mat-icon>
    </button>
    <button mat-icon-button (click)="openContactSearch()" *appHasRightId="kontaktRight" matTooltip="Kontakte suchen">
      <mat-icon>contacts</mat-icon>
    </button>
    <!--
    <button mat-icon-button (click)="openChangelogOverlay()"><mat-icon>help</mat-icon>
      <span class="badge" *ngIf="versionNotificationNeeded">!</span>
    </button>
    -->
    <div class="profile-area" #profile (click)="openUserMenu()" [ngClass]=" {'area-open': userOverlayOpen}"
         matTooltip="Benutzerprofil anzeigen">
      <div
        class="user-icon"
        [ngStyle]="{
              'background-image': 'url('+ getUserImagePath() + '), url('+staticPath.getFallbackPath()+')'
            }"
      ></div>
      <mat-icon *ngIf="!userOverlayOpen">keyboard_arrow_down</mat-icon>
      <mat-icon *ngIf="userOverlayOpen" class="open">keyboard_arrow_up</mat-icon>
    </div>
  </div>
  <div *ngIf="userOverlayOpen && loggedInUser" class="user-overlay">
    <div class="data-container">
      <app-person-container [name]="username" [mail]="loggedInUser.loginEmail"></app-person-container>
    </div>
    <div class="navigation-container">
      <mat-divider></mat-divider>
      <mat-selection-list>
        <mat-list-item (click)="goToSettings()">
          <mat-icon matListItemIcon>settings_applications</mat-icon>
          Einstellungen
        </mat-list-item>
        <mat-list-item (click)="openChangelogOverlay()">
          <mat-icon matListItemIcon>help</mat-icon>
          Versions-Info <span class="badge" *ngIf="versionNotificationNeeded">!</span>
        </mat-list-item>
        <mat-list-item (click)="logout()">
          <mat-icon matListItemIcon>exit_to_app</mat-icon>
          Abmelden
        </mat-list-item>
      </mat-selection-list>
    </div>
  </div>
</div>
<div class="main" (click)="closeOverlays()" [ngClass]="getMainClass()">
  <app-global-sidenav [globalDrawerItems]="globalDrawerItems" [updateOverlayShown]="updateApp"
                      #mainSideNav></app-global-sidenav>
  <div class="nav-wrapper"
       [ngClass]="{ 'full-width': deviceService.isMobile()}">
    <app-tab-bar></app-tab-bar>
    <div id="main-container" class="main-container">
      <div class="max-width-div" [hidden]="globalLoading">
        <router-outlet></router-outlet>
      </div>
      <div class="max-width-div" *ngIf="globalLoading">
        <app-loader [global]="true"></app-loader>
      </div>

    </div>
    <div class="app-version" textSmall
         [ngClass]="{'above-footer' : footer && footer.footerVersion && footer.footerVersion.versionen && footer.footerVersion.versionen.length > 1}">
      Version: {{clientVersion}}</div>
    <app-footer-version-select #footer></app-footer-version-select>
  </div>
</div>
